// extracted by extract-css-chunks-webpack-plugin
module.exports = {"inlineCategoryContent":"css-2fr3tkLQZh","inlineCategoryContent__left":"css-3IO5buflcR"};